export default {
  'meta': {
    'langName': 'ESTONIAN',
    'lang': 'Eesti'
  },
  'title': 'TOOTE TAGASIKUTSUMINE: KORVPALLIKORV B900 BOX NBA TARMAK',
  'description': 'Oleme tuvastanud riski, et meie korvpallikorvi B900 post võib kukkuda, kui seda kasutatakse või selle kõrgust reguleeritakse ilma vändata. \nTeie ohutuse tagamiseks lõpetage viivitamatult igasugune kasutamine, kui kõrguse reguleerimise vänt ei ole paigaldatud. \nTeie toote turvalisemaks muutmine on võimalik lihtsa protseduuriga ja komplektiga, mis toimetatakse teile tasuta kohale. \nSellele tagasikutsumisele pühendatud veebileht on praegu hoolduse all. Veebileht juhendab teid selle toimingu sooritamise sammude osas. \nTeavitame teid niipea, kui see on saadaval (juuli jooksul). \n\n',
  'status': 'Translation validated by COUNTRY'
} as const
